import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { ResolveTeamsService } from '@app/core/services/resolvers/resolve-teams.service';
import * as fromRoot from '@app/reducers/index';
import { getProtocolHostnameAndPort, getProtocolMainDomainAndPort, isHostnameCNAME } from '@app/shared/helpers/location';
import { ThemeSimplified } from '@app/shared/helpers/theme';
import { Team } from '@app/shared/models/team';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GetDropboxPreviewOutput } from '@smash-sdk/transfer/ejs/01-2024';
import { GetRecordOutput } from '@smash-sdk/domain/ejs/01-2024';
import { Observable, Subscription } from 'rxjs';
import { ScrollPrepareService } from '@app/core/services/scroll-prepare.service';

@Component({
  selector: 'app-smash-header',
  templateUrl: './smash-header.component.html',
  styleUrls: ['./smash-header.component.scss']
})
export class SmashHeaderComponent implements OnChanges, OnDestroy {

  @Output() menuToggle: EventEmitter<any> = new EventEmitter<any>();
  @Output() switchUploaderMode: EventEmitter<any> = new EventEmitter<any>();
  @Output() goToUploader: EventEmitter<any> = new EventEmitter<any>();
  @Input() state: boolean;
  @Input() showMenu: boolean;
  @Input() headerColor?: string;
  @Input() captionColor?: string;
  @Input() shadowOnElementsEnabled = true;
  @Input() theme: ThemeSimplified;
  @Input() uploaderMode: 'Dropbox' | 'Transfer';
  @Input() domain: GetRecordOutput['record'];
  @Input() step: 'LANDING' | 'PREPARE' | 'SEND';
  @Input() dropboxPreview: GetDropboxPreviewOutput['dropbox'];
  @Input() dropboxPreviewLoading: boolean;
  @Input() headerLocation?: string;

  @ViewChild('collabLogo') collabLogo: ElementRef;
  @ViewChild('collabLogoContainer') collabLogoContainer: ElementRef;

  isMainDomain$: Observable<boolean>;
  isLoggedIn$: Observable<boolean>;
  showCollabLogo = false;
  showVerticalLine = false;
  showTextCollab = false;
  collabLogoLoaded = false;
  scrollActivate = false;
  routeToHome = isHostnameCNAME() ? getProtocolHostnameAndPort() : getProtocolMainDomainAndPort();
  subscriptions: Subscription[] = [];
  isLoggedIn: boolean;
  selectedTeam: Team;
  constructor(
    private translateService: TranslateService,
    private readonly store$: Store<fromRoot.State>,
    private resolveTeamsService: ResolveTeamsService,
    private scrollPrepare: ScrollPrepareService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.isMainDomain$ = this.store$.select(fromRoot.getIsMainDomain);
    this.subscriptions.push(
      this.resolveTeamsService.resolve().subscribe((res) => {
        this.isLoggedIn = res.isLoggedIn;
        this.selectedTeam = res.selectedTeam;
      }),
      this.scrollPrepare.getScrollDirection().subscribe((val) => this.scrollActivate = !!(val === 'up')),
    );
  }

  ngOnChanges() {
    if (isPlatformBrowser(this.platformId) && this.theme) {
      this.startTimeApparitionCollabItemsLayout();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }

  onToggleMenu(event) {
    this.menuToggle.emit(event);
    this.closeTextCollab();
  }

  onGoToUploader(event) {
    this.goToUploader.emit(event);
  }

  startTimeApparitionCollabItemsLayout() {

    setTimeout(() => {
      this.showVerticalLine = true;
    }, 1000);
    setTimeout(() => {
      this.showCollabLogo = true;
    }, 2000);
    setTimeout(() => {
      this.showTextCollab = true;
      setTimeout(() => {
        this.showTextCollab = false;
      }, 3000);
    }, 2000);
  }

  onCollabLogoLoaded() {
    this.collabLogoLoaded = true;
  }

  toggleTextCollab() {
    this.showTextCollab = !this.showTextCollab;
  }

  closeTextCollab() {
    this.showTextCollab = false;
  }

  redirectTo() {
    if (isPlatformBrowser(this.platformId) && this.theme?.teasing?.headerUrl) {
      window.open(
        getProtocolHostnameAndPort() + '/redirect?url=' + encodeURIComponent(this.translateService.instant(this.theme?.teasing?.headerUrl)),
        '_blank'
      );
    }
  }

  canDisplayToggleUploaderMode() {
    return this.step === 'LANDING' && this.isLoggedIn && !!this.selectedTeam && !this.dropboxPreview && !this.dropboxPreviewLoading && this.domain?.options?.transferMode?.options?.length > 1;
  }

  onSwitchUploaderMode(event: Event) {
    const mode = (event.target as HTMLInputElement).checked ? 'Dropbox' : 'Transfer';
    this.switchUploaderMode.emit(mode);
  }

  get logoCollabHeight() {
    return (this.collabLogo?.nativeElement?.clientHeight ?? 0) + 'px'
  }

  get logoCollabWidth() {
    return (this.collabLogo?.nativeElement?.clientWidth ?? 0) + 'px'
  }

  get logoCollabTranslationX() {
    if (this.showCollabLogo) {
      return 'translateX(0px)';
    } else if (this.collabLogo?.nativeElement?.clientWidth) {
      return `translateX(calc(-${this.collabLogo?.nativeElement?.clientWidth}px - 30px))`;
    }
  }

  get verticalLineHeight() {
    if (this.collabLogo?.nativeElement?.clientHeight && this.collabLogoContainer?.nativeElement?.offsetTop) {
      return this.collabLogo?.nativeElement?.clientHeight + this.collabLogoContainer?.nativeElement?.offsetTop + 'px';
    } else {
      return '0px';
    }
  }
}
